<template style="height: 100%;">
    <div style="height: 100%;display: flex" id="homeBox">
        <el-row class="video-tree flex"  style="width: 100%;">

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <left-tree @showData="showData"  ref="tree" :isuseSearch="true"></left-tree>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%;min-width: 320px;width: 100%;flex: 1;">

                <div  style="display: flex">
                    <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>

                    <div class="df">
                        <div class="flex w66 alc">
                            <el-input  class="marr4" style=""  v-model="vc_search" placeholder="请输入" clearable size="mini"></el-input>
                            <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
                        </div>
                    </div>
                </div>
                <el-table  class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                           :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>
                    <el-table-column prop="vc_username" label="姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_phone" label="手机号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_dept" label="部门" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_gsname" label="公司" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="i_userid" label="用户ID" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" label="操作">
                        <template slot-scope="scope">
                            <el-button  type="text" size="mini" @click="detailFun(scope.row,'edit')">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--        分页器-->
                <div class="block">
                    <div class="pages">
                        <div class="choosepage flexother mrt20 fl">
                            <el-pagination small @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="this.currentPage"
                                           :page-sizes="[20, 40, 60, 80]" :page-size="this.pageSize" layout="total,sizes" :total="this.total">
                            </el-pagination>
                            <el-pagination small :pager-count="5" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                           :current-page="this.currentPage" :page-size="this.pageSize" layout="prev, pager, next, jumper" :total="this.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div :class="baseerp+'div'">
                    <el-dialog :title="detailtitle" width="600px" top="30px" :visible.sync="dialogVisible"
                               :close-on-click-modal="false" @close="closeFun">
                        <detail-page :data="propData" v-if="dialogVisible" @close="closeFun"></detail-page>
                    </el-dialog>

                </div>


            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import LeftTree from "../personInformation/LeftTree";
    import DetailPage from "./DetailPage";
    export default {
        name: "workManage",
        components:{

            LeftTree,
            DetailPage

            // tabTree
        },
        data(){
            return{
                isright:true,//树显示按钮
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:20,//条
                total:0,//总数
                baseerp:'',//公共样式
                tableHeight:0,//列表高度
                detailtitle:'',
                dialogVisible:false,
                propData:{},
                treespan:4,
                rightspan:20,
                treeData:null,
                vc_search:'',
                i_rytypeList:[],
                i_rytype:'',
                i_rystateList:[{i_id:1,vc_name:'在职'},{i_id:-1,vc_name:'离职'},{i_id:2,vc_name:'核算'}],
                i_rystate:'',
            }
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();
            })
            // this.getUserList()
        },
        methods:{

            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            ...mapActions(["getCurrentMenuId"]),
            ryStateChange(){
                this.getUserTypeList();
                this.i_rytype='';
            },
            rytypeChange(){
                if(!this.i_rystate){
                    this.$message.error('先选人员状态');
                }
                //this.vc_rytype=this.i_rytypeList.find(i=>row.i_rytype==i.i_id).vc_name
            },
            async getUserTypeList(){
                let param={
                    vc_search:this.type_search,
                };
                let res=await API.getUserTypeList(param);
                if ( res.code == 1 ){
                    //this.i_rytypeList=res.data;
                    let list = [];
                        list = res.data.filter(item=>item.i_state==this.i_rystate)
                    this.i_rytypeList=this.i_rystate?list:res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            closeFun(type){
                this.dialogVisible=false

            },
            //新增 编辑
            detailFun(val,type){

                this.detailtitle='防暴手机列表';
                this.dialogVisible=true;
                this.propData={
                    type:type,
                    val:val
                }


            },
            showData(val){
                this.treeData=val;
                this.currentPage =1;
                this.getUserList();
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getUserList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getUserList()
            },
            searchFun(){
                this.currentPage=1
                this.getUserList()
            },
            async getUserList() {
                let params = {
                    i_dept:this.treeData.i_id,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.vc_search,
                    i_rytype:this.i_rytype,
                    i_rystate:this.i_rystate,
                    isForMobile:1,
                };
                let res = await API.getUserList(params);
                if (res.code == 1) {
                    this.tableData=res.data.userList;
                    this.total=res.data.total;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .df{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .row-expand-cover .el-table__expand-icon {
            visibility: hidden;
        }
        .el-table--enable-row-transition{
            /*min-width: 64.286rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
    /deep/{
        .el-dialog{
            min-width: 900px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table__expanded-cell[class*=cell]{
            padding: 5px;
        }
        .dtj{
            color: #409EFF;
        }
        .tg{
            color: #03cb45;
        }
        .spz{
            color: #ffbe06;
        }
        .wtg{
            color: #ff0500;
        }
        .yzf{
            color: #878787;
        }
    }

</style>